import { render } from "./LoginForm.vue?vue&type=template&id=0bf8c435&scoped=true"
import script from "./LoginForm.vue?vue&type=script&lang=js"
export * from "./LoginForm.vue?vue&type=script&lang=js"

import "./LoginForm.vue?vue&type=style&index=0&id=0bf8c435&lang=scss"
import "./LoginForm.vue?vue&type=style&index=1&id=0bf8c435&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bf8c435"]])

export default __exports__